/* eslint quotes: ["error", "single", { "avoidEscape": true }] */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Link from '../../Link';
import TranslationProvider from '../../../providers/TranslationProvider';

import '../AccountPage.scss';
import './HelpAndFeedback.scss';
import {
  getUserThunk,
  selectIsConcierge,
  selectIsGlobalDiningAccess,
} from '../../../reducers/userSlice';

const helpAndFeedbackPropTypes = {
  getUser: PropTypes.func.isRequired,
};

const HelpAndFeedback = ({ getUser }) => {
  useEffect(() => {
    getUser();
  }, []);
  return (
    <div className="HelpAndFeedback">
      <TranslationProvider translationKey="help_and_feedback_heading">
        <h2 className="AccountPage__title">Help & Feedback</h2>
      </TranslationProvider>

      <TranslationProvider translationKey="help_and_feedback_subheading">
        <p className="AccountPage__subtitle">We’d love to hear from you.</p>
      </TranslationProvider>

      <TranslationProvider translationKey="help_and_feedback_cancel_question">
        <h3 className="HelpAndFeedback__content-header">
          Trying to cancel an existing reservation?
        </h3>
      </TranslationProvider>

      <TranslationProvider translationKey="help_and_feedback_cancel_answer">
        <p className="HelpAndFeedback__content-body">
          If you are trying to cancel an existing reservation, please refer to
          the cancellation policy that was provided in your confirmation email,
          as policy varies by restaurant and by reservation. (This information
          is also available in the Resy app and is stated with your
          reservation).
        </p>
      </TranslationProvider>

      <TranslationProvider translationKey="help_and_feedback_join">
        <h3 className="HelpAndFeedback__content-header">
          I own a restaurant and would like to join!
        </h3>
      </TranslationProvider>
      <div className="HelpAndFeedback__content-body">
        <TranslationProvider translationKey="help_and_feedback_join_contact">
          <p className="d-inline">
            Smart. We currently work with more than 9,000 restaurant partners
            and would love to have you, too.&nbsp;
          </p>
        </TranslationProvider>
        &nbsp;
        <TranslationProvider translationKey="help_and_feedback_more_information">
          <Link target="_blank" href="https://resy.com/join/">
            More&nbsp;Information &rsaquo;
          </Link>
        </TranslationProvider>
      </div>

      <div>
        <TranslationProvider translationKey="help_and_feedback_additional_questions">
          <p
            className="d-inline HelpAndFeedback__content-body"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: `
                If you have any additional questions, see <a href="/about-and-help">About & Help</a>.
              `,
            }}
          />
        </TranslationProvider>
      </div>
    </div>
  );
};

HelpAndFeedback.propTypes = helpAndFeedbackPropTypes;

const mapStateToProps = (state) => ({
  isConcierge: selectIsConcierge(state),
  isGlobalDiningAccess: selectIsGlobalDiningAccess(state),
});
const mapDispatchToProps = { getUser: getUserThunk };
export { helpAndFeedbackPropTypes, HelpAndFeedback as ComponentUnderTest };
export default connect(mapStateToProps, mapDispatchToProps)(HelpAndFeedback);
